import { axios, BaseApiUrl } from '../axios_config';

// 移动端插入盘点
export const addStockTaking = params =>{
    return axios.post(`${BaseApiUrl}/InventoryQuery/AddStockTaking`, { ...params }).then(res => res.data);
}

// 移动端查询未打包数据汇总
export const getBaleTotal = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetStockingPlanRelationByTotalAsync`, { params }).then(res => res.data);
}

// 移动端按sku查询打包列表
export const getBaleForSku = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetStockingPlanRelationBySKUAsync`, { params }).then(res => res.data);
}

// 移动端按货柜号查询打包列表
export const getBaleForContainer = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetStockingPlanRelationByContainerNoAsync`, { params }).then(res => res.data);
}

// 移动端查询箱号是否存在
export const getBaleHasBoxNum = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetStockingBoxSumByContainerNoBoxNoAsync`, { params }).then(res => res.data);
}

// 移动端按sku备货计划详情
export const getBaleSkuDetail = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetTaskMobileDataDetailByAsync`, { params }).then(res => res.data);
}

// 移动端按货柜号查询备货计划详情
export const getBaleContainerDetail = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetTaskMobileDetailBycontainerNoAsync`, { params }).then(res => res.data);
}

// 移动端打包
export const AddReadyTaskPackaging = params =>{
    return axios.post(`${BaseApiUrl}/ReadyforTask/AddReadyforMobileTaskPackaging`, {...params}).then(res => res.data);
}

// 移动端查询是否是混箱
export const getIsMixingBox = params =>{
    return axios.get(`${BaseApiUrl}/ReadyforTask/GetTaskMobileDataDetailCountAsync`, {params}).then(res => res.data);
}

// 移动端打印后的回调接口
export const UpdateStockingPlanIsPrintBarCode = params =>{
    return axios.post(`${BaseApiUrl}/ReadyforTask/UpdateStockingPlanIsPrintBarCode`, [...params]).then(res => res.data);
}


// 移动端打包校验
export const CheckAddReadyTaskPackaging = params =>{
    return axios.post(`${BaseApiUrl}/ReadyforTask/CheckAddReadyforMobileTaskPackaging`, {...params}).then(res => res.data);
}

// 打包打印产品信息
export const TaskPackagingPrintSku = params =>{
    return axios.post(`${BaseApiUrl}/ReadyforTask/TaskPackagingPrintSku`, [ ...params ]).then(res => res.data);
}
//打印托唛
export const PrintPallet = params =>{
    return axios.post(`${BaseApiUrl}/ReadyforTask/PrintPallet`, {...params}).then(res => res.data);
}
